import { useState, useEffect } from "react";
import { getStorageUrl } from "../../lib/api";
import { ImagePlacementCard } from "./ImagePlacementCard";
import { LayoutSection } from "../../lib/types";
import { ImagePlacement } from "./ImagePlacementManager";

interface ImagePlacementListProps {
  sections: LayoutSection[];
  placements: ImagePlacement[];
  onDelete: (id: number) => Promise<void>;
  onUpdate: () => Promise<void>;
}

interface ImageUrlCache {
  [key: string]: string;
}

export function ImagePlacementList({
  sections,
  placements,
  onDelete,
  onUpdate,
}: ImagePlacementListProps) {
  const [imageUrls, setImageUrls] = useState<ImageUrlCache>({});

  // 画像URLの取得
  useEffect(() => {
    const urls: ImageUrlCache = {};
    placements.forEach(placement => {
      if (placement.illustration.storage_path) {
        urls[placement.illustration.storage_path] = getStorageUrl("illustrations", placement.illustration.storage_path);
      }
    });
    setImageUrls(urls);
  }, [placements]);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-center text-gray-700">
        配置済み画像・アイコン一覧
      </h2>
      <div className="space-y-4">
        {sections.map((section) => {
          const sectionPlacements = placements.filter(
            (p) => p.section_id === section.id
          );
          if (sectionPlacements.length === 0) return null;

          const maxOrder = Math.max(
            ...sectionPlacements.map((p) => p.sort_order),
            0
          );

          return (
            <div key={section.id} className="border rounded-lg p-4">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                {section.section_name}
                <span className="text-sm text-gray-500 ml-2">
                  ({sectionPlacements.length} / {section.max_images})
                </span>
              </h3>
              <div className="grid grid-cols-1 gap-4">
                {sectionPlacements.map((placement) => (
                  <ImagePlacementCard
                    key={placement.id}
                    placement={placement}
                    imageUrl={imageUrls[placement.illustration.storage_path]}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                    maxOrder={maxOrder}
                    sectionPlacements={sectionPlacements}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
